export class OptimizationGroup {
	constructor() {
	}
} 
